import { CategoryPathType } from '@screens/Category/model/types/categoryPathsConfig';
import {
  CLOSET_PATH,
  CLOSET_VALUE,
  FLOOR_PATH,
  FLOOR_VALUE,
  HANDING_PATH,
  HANDING_VALUE,
  LED_MIRRORS_PATH,
  LED_MIRRORS_VALUE,
  MIRROR_CABINETS_PATH,
  MIRROR_CABINETS_VALUE,
  MIRRORS_PATH,
  MIRRORS_VALUE,
  PEDESTAL_PATH,
  PEDESTAL_VALUE,
  UNDER_WASHING_MACHINE_PATH,
  UNDER_WASHING_MACHINE_VALUE,
  WITH_SINK,
  WITH_SINK_VALUE
} from '@shared/constants/catalog';
import {
  ID_CLOSET_ATTRIBUTE,
  ID_INSTALLATION_ATTRIBUTE,
  ID_MIRRORS_ATTRIBUTE,
  ID_PEDESTAL_ATTRIBUTE,
  ID_VIEW_MIRRORS_ATTRIBUTE
} from '@shared/constants/keys';
import { ROUTES } from '@shared/constants/routes';
import img3_1 from '@widgets/CategoriesMenu/images/shkaf-napolnyi.png';
import img3_3 from '@widgets/CategoriesMenu/images/shkaf-pod-stiralku.png';
import img3_2 from '@widgets/CategoriesMenu/images/shkaf-podvesnoi.png';
import img1_3 from '@widgets/CategoriesMenu/images/tumba_pod_stiralku.png';
import img1_1 from '@widgets/CategoriesMenu/images/tumba-napolnaya.png';
import img1_2 from '@widgets/CategoriesMenu/images/tumba-navesnaya.jpg';
import img1_4 from '@widgets/CategoriesMenu/images/tumba-s-rakovinoi.png';
import img2_1 from '@widgets/CategoriesMenu/images/zerkala-s-podsvetkoi.png';
import img2_2 from '@widgets/CategoriesMenu/images/zerkalnui-shkaf.png';

export const PATH: Record<string, CategoryPathType> = {
  [PEDESTAL_PATH]: {
    url: ROUTES.PEDESTAL,
    translit: PEDESTAL_PATH,
    label: 'Тумбы для ванной комнаты',
    value: PEDESTAL_VALUE,
    categoryId: ID_PEDESTAL_ATTRIBUTE,
    subcategoryId: ID_INSTALLATION_ATTRIBUTE,
    subcategories: {
      [FLOOR_PATH]: {
        img: img1_1.src,
        label: 'Напольные тумбы',
        value: FLOOR_VALUE,
        url: ROUTES.FLOOR_PEDESTAL
      },
      [HANDING_PATH]: {
        img: img1_2.src,
        label: 'Подвесные тумбы',
        value: HANDING_VALUE,
        url: ROUTES.HANDING_PEDESTAL
      },
      [UNDER_WASHING_MACHINE_PATH]: {
        img: img1_3.src,
        label: 'Тумбы под стиральную машину',
        value: UNDER_WASHING_MACHINE_VALUE,
        url: `${ROUTES.UNDER_WASHING_MACHINE_PEDESTAL.replaceAll('_', '-')}`
      },
      [WITH_SINK]: {
        img: img1_4.src,
        label: 'Тумбы с раковиной',
        value: WITH_SINK_VALUE,
        url: `${ROUTES.WITH_SINK_PEDESTAL.replaceAll('_', '-')}`
      }
    }
  },
  [CLOSET_PATH]: {
    url: ROUTES.CLOSET,
    label: 'Шкафы',
    value: CLOSET_VALUE,
    translit: CLOSET_PATH,
    categoryId: ID_CLOSET_ATTRIBUTE,
    subcategoryId: ID_INSTALLATION_ATTRIBUTE,
    subcategories: {
      [FLOOR_PATH]: {
        img: img3_1.src,
        label: 'Напольные шкафы',
        value: FLOOR_VALUE,
        url: ROUTES.FLOOR_CLOSET
      },
      [HANDING_PATH]: {
        img: img3_2.src,
        label: 'Подвесные шкафы',
        value: HANDING_VALUE,
        url: ROUTES.HANDING_CLOSET
      },
      [UNDER_WASHING_MACHINE_PATH]: {
        img: img3_3.src,
        label: 'Шкафы под стиральную машину',
        value: UNDER_WASHING_MACHINE_VALUE,
        url: `${ROUTES.UNDER_WASHING_MACHINE_CLOSET.replace('_', '-')}`
      }
    }
  },
  [MIRRORS_PATH]: {
    url: ROUTES.MIRRORS,
    label: 'Зеркала',
    value: MIRRORS_VALUE,
    translit: MIRRORS_PATH,
    categoryId: ID_MIRRORS_ATTRIBUTE,
    subcategoryId: ID_VIEW_MIRRORS_ATTRIBUTE,
    subcategories: {
      [LED_MIRRORS_PATH]: {
        img: img2_1.src,
        label: 'Зеркала с подсветкой',
        value: LED_MIRRORS_VALUE,
        url: `${ROUTES.LED_MIRRORS.replaceAll('_', '-')}`
      },
      [MIRROR_CABINETS_PATH]: {
        img: img2_2.src,
        label: 'Зеркальные шкафы',
        value: MIRROR_CABINETS_VALUE,
        url: `${ROUTES.MIRROR_CABINETS.replaceAll('_', '-')}`
      }
    }
  }
};
